__webpack_require__.p = "/cybersecurity/_next/";